import React, { useEffect, useState } from 'react';
import { Grid, Text } from 'elements';
import { postRecommendCase, getCaseItem } from 'libs/api/case';
import { TCase } from 'modules/case/types';
import { CWindowWidth } from 'constants/base.const';
import { Button } from 'antd';

type TInformationParams = {
  item: TCase;
  refresh: () => void;
};

const Information = ({ item, refresh }: TInformationParams) => {
  const [goodCount, setGoodCount] = useState(0);
  const [isSatisfaction, setIsSatisfaction] = useState<boolean | null>();

  useEffect(() => {
    if (item.good_count) {
      setGoodCount(item.good_count);
    }

    setIsSatisfaction(item.is_user_satisfactions);
  }, []);

  const recommend = async (is: boolean) => {
    // 추천 or 비추천을 누르면 post를해서 그 콘텐츠의 id와 추천을 눌렀는지 비추천을 눌렀는지 함께 보냄
    const { success } = await postRecommendCase(item.id, is);
    // if (success) refresh();
    //리프레시를 하는게 아니라 데이터 따로 뽑아서
    if (success) {
      const { success, data } = await getCaseItem(item.id);
      if (success) {
        setGoodCount(data.result.good_count);
        setIsSatisfaction(data.result.is_user_satisfactions);
      }
    }
  };

  return (
    <Grid
      maxWidth={`${CWindowWidth}px`}
      padding='35px 50px'
      md={{ padding: '35px 20px' }}
      sm={{ padding: '16px' }}
    >
      <Grid gap='15px' justify='space-between'>
        <Grid
          isInline
          width='30%'
          maxWidth='330px'
          minHeight='180px'
          image={item.thumbnail_images}
          md={{ width: '100%', maxWidth: '100%' }}
        />

        <Grid isInline width='calc(70% - 15px)' md={{ width: '100%' }}>
          <Grid>
            <Text size='2rem' sm={{ size: '1.6rem' }}>
              {item.title}
            </Text>
          </Grid>
          <Grid sm={{ padding: '0 5px' }}>
            <Text>{item.description}</Text>
          </Grid>
          {!!item.question_tag && item.question_tag.length > 0 && (
            <Grid gap='5px' marginTop='8px' sm={{ padding: '0 5px' }}>
              {item.question_tag.map((t) => (
                // <Tag key={t}>{t}</Tag>
                <Button
                  className='small'
                  style={{
                    minHeight: '22px',
                    marginRight: '5px',
                    fontSize: '1rem',
                  }}
                  key={t}
                >
                  {' '}
                  {t}{' '}
                </Button>
              ))}
            </Grid>
          )}
          <Grid display='none' md={{ display: 'flex' }} sm={{ padding: '0 5px' }}>
            <Grid gap='0 20px' marginTop='8px'>
              {/* 조회수 */}
              {/* <Text>조회수 {item.hit_count}</Text> */}
              <Text>조회수 {item.hit_count}</Text>
              {/* 추천수 */}
              <Text>추천 {goodCount}</Text>

              <Grid isInline margin='0 0 0 50px'>
                <Text>난이도 {item.difficulty} / 5.0</Text>
              </Grid>
            </Grid>
            <Grid gap='8px' align='center' marginTop='8px'>
              <Text disabled={!item.is_payed}>이 case</Text>
              {/* 이 케이스에 돈을 지불했어야 추천/비추천 버튼이 활성화된다 */}
              <Button
                disabled={!item.is_payed}
                className={`small secondary ${isSatisfaction ? '' : 'outline'}`}
                onClick={() => recommend(true)}
              >
                추천
              </Button>
              <Button
                disabled={!item.is_payed}
                className={`small danger ${isSatisfaction === false ? '' : 'outline'}`}
                onClick={() => recommend(false)}
              >
                비추천
              </Button>
              <Text disabled={!item.is_payed}>하기</Text>
            </Grid>
          </Grid>

          <Grid md={{ display: 'none' }}>
            <Grid marginTop='8px'>
              <Text>조회수 {item.hit_count}</Text>
            </Grid>
            <Grid marginTop='8px' align='center' gap='0 50px'>
              <Text>추천 {goodCount}</Text>
              <Grid isInline gap='8px' align='center' md={{ width: '100%' }}>
                <Text disabled={!item.is_payed}>이 case</Text>
                <Button
                  disabled={!item.is_payed}
                  className={`small secondary ${isSatisfaction ? '' : 'outline'}`}
                  onClick={() => recommend(true)}
                >
                  추천
                </Button>
                <Button
                  disabled={!item.is_payed}
                  className={`small danger ${isSatisfaction === false ? '' : 'outline'}`}
                  onClick={() => recommend(false)}
                >
                  비추천
                </Button>
                <Text disabled={!item.is_payed}>하기</Text>
              </Grid>
            </Grid>
          </Grid>
          <Grid marginTop='8px' md={{ display: 'none' }}>
            <Text>난이도 {item.difficulty} / 5.0</Text>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Information;
